import { render, staticRenderFns } from "./ParameterSection.vue?vue&type=template&id=2d25e488&scoped=true&"
import script from "./ParameterSection.vue?vue&type=script&lang=js&"
export * from "./ParameterSection.vue?vue&type=script&lang=js&"
import style0 from "./ParameterSection.vue?vue&type=style&index=0&id=2d25e488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25e488",
  null
  
)

export default component.exports